import React from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";

import { PlayerBonusListMode } from "types/playerBonuses";

import styles from "./ListBonusesTab.module.scss";

interface BonusModeSwitcherProps {
  mode: PlayerBonusListMode;
  totalItems?: number;
  isLoading?: boolean;
  onChange: (mode: PlayerBonusListMode) => void;
}

const BonusModeSwitcher: React.FC<BonusModeSwitcherProps> = ({
  mode,
  totalItems = 0,
  isLoading = false,
  onChange,
}) => {
  const { t } = useTranslation();

  const modeTabs: { id: PlayerBonusListMode; label: string }[] = [
    { id: "attached", label: t("attached") },
    { id: "offers", label: t("offers") },
  ];

  return (
    <div
      className={cn(
        styles.modeSwitcher,
        isLoading && styles.modeSwitcherDisabled,
      )}
      role="tablist"
      aria-label={`${t("attached")} / ${t("offers")}`}
    >
      {modeTabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={mode === tab.id}
          className={cn(
            styles.modeSwitcherItem,
            mode === tab.id && styles.modeSwitcherItemActive,
          )}
          disabled={isLoading}
          onClick={() => {
            if (!isLoading && tab.id !== mode) {
              onChange(tab.id);
            }
          }}
        >
          {tab.label}
          {!isLoading && mode === tab.id ? ` (${totalItems})` : ""}
        </button>
      ))}
    </div>
  );
};

export default BonusModeSwitcher;
